import React from 'react'
import styles from './hero-featured.module.css'

export default function HeroFeatured() {
  const curveId = "heroFeaturedCurveTop" // Unique ID for the path
  
  return (
    <div className={styles.sticker}>
      <svg viewBox="0 0 100 100" className={styles.svg}>
        <defs>
          {/* 
            Top arc (sweep 1,1): curve along top. Radius 36 so the path sits
            ~2px below the inner border and doesn't overlap the white border.
          */}
          <path id={curveId} d="M 14,50 A 36,36 0 1,1 86,50" />
        </defs>
        
        {/* Inner Border */}
        <circle cx="50" cy="50" r="46" className={styles.innerBorder} />
        
        {/* Curved Top Text */}
        <text className={styles.top}>
          <textPath href={`#${curveId}`} startOffset="50%" textAnchor="middle">
            FEATURED ON
          </textPath>
        </text>
        
        {/* Middle Text */}
        <text x="50" y="58" className={styles.middle} textAnchor="middle">
          NPR
        </text>
        
        {/* Bottom Text */}
        <text x="50" y="74" className={styles.bottom} textAnchor="middle">
          LIFE KIT
        </text>
      </svg>
    </div>
  )
}
